module.exports = __webpack_public_path__ + "img/diners club.c1588bd0.png";